import React from 'react';
import { NavLink } from 'react-router-dom';
import { Translate } from "react-localize-redux";
import './styles.scss';

export class SuccessPage extends React.Component {
  render() {
    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center">

        <div className="container">
          <div className="row">
            <div className="col text-center">
              <h3 id="success-title">Success</h3>
            </div>
          </div>

          <div className="row">
            <div className="col text-center">
              <p>Welcome to myHelloHello!</p>
            </div>
          </div>

          <div className="row">
            <div className="col text-center">
              <p>Help us build the worldwide phone directory.</p>
            </div>
          </div>

          <div className="row">
            <div className="col text-center">
              <p>Send your contact card to friends, family and colleagues.</p>
            </div>
          </div>

          <div className="row">
            <div className="col text-center">
              <NavLink
                to="/share-card"
                className="btn btn-primary"
              >
                <Translate id="SendContactCard" />
              </NavLink>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default SuccessPage;



// WEBPACK FOOTER //
// ./src/components/pages/SuccessPage/SuccessPage.jsx